var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_841_684",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_841_684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.925C11.6833 11.425 12.0167 10.874 12.25 10.272C12.4833 9.67 12.6 9.046 12.6 8.4C12.6 7.75983 12.4833 7.14142 12.25 6.54475C12.0167 5.94825 11.6833 5.39167 11.25 4.875C11.3833 4.84167 11.5083 4.82083 11.625 4.8125C11.7417 4.80417 11.8667 4.8 12 4.8C13 4.8 13.85 5.15 14.55 5.85C15.25 6.55 15.6 7.4 15.6 8.4C15.6 9.4 15.25 10.25 14.55 10.95C13.85 11.65 13 12 12 12C11.8667 12 11.7375 11.9958 11.6125 11.9875C11.4875 11.9792 11.3667 11.9583 11.25 11.925ZM16.2 19.2V16.9C16.2 16.2167 16.0417 15.5792 15.725 14.9875C15.4083 14.3958 14.9667 13.8917 14.4 13.475C15.5333 13.7417 16.6167 14.1083 17.65 14.575C18.6833 15.0417 19.2 15.8167 19.2 16.9V19.2H16.2ZM19.5 13.2V11.1H17.4V9.3H19.5V7.2H21.3V9.3H23.4V11.1H21.3V13.2H19.5ZM7.2 12C6.2 12 5.35 11.65 4.65 10.95C3.95 10.25 3.6 9.4 3.6 8.4C3.6 7.4 3.95 6.55 4.65 5.85C5.35 5.15 6.2 4.8 7.2 4.8C8.2 4.8 9.05 5.15 9.75 5.85C10.45 6.55 10.8 7.4 10.8 8.4C10.8 9.4 10.45 10.25 9.75 10.95C9.05 11.65 8.2 12 7.2 12ZM0 19.2V16.9C0 16.4765 0.104167 16.0873 0.3125 15.7325C0.520833 15.3775 0.808333 15.0833 1.175 14.85C2.075 14.2833 3.03783 13.8667 4.0635 13.6C5.08917 13.3333 6.13083 13.2 7.1885 13.2C8.24617 13.2 9.28333 13.3417 10.3 13.625C11.3167 13.9083 12.2917 14.3167 13.225 14.85C13.575 15.0833 13.8583 15.3775 14.075 15.7325C14.2917 16.0873 14.4 16.4765 14.4 16.9V19.2H0ZM7.1875 10.2C7.67917 10.2 8.10417 10.025 8.4625 9.675C8.82083 9.32483 9 8.904 9 8.4125C9 7.92083 8.82083 7.49583 8.4625 7.1375C8.10417 6.77917 7.67917 6.6 7.1875 6.6C6.696 6.6 6.27517 6.77917 5.925 7.1375C5.575 7.49583 5.4 7.92083 5.4 8.4125C5.4 8.904 5.575 9.32483 5.925 9.675C6.27517 10.025 6.696 10.2 7.1875 10.2ZM1.8 17.4H12.6V16.9C12.6 16.7988 12.575 16.7069 12.525 16.6242C12.475 16.5414 12.4083 16.4667 12.325 16.4C11.525 15.9667 10.6958 15.625 9.8375 15.375C8.97917 15.125 8.09583 15 7.1875 15C6.27917 15 5.39583 15.1208 4.5375 15.3625C3.67917 15.6042 2.85833 15.95 2.075 16.4C1.99167 16.4667 1.925 16.5414 1.875 16.6242C1.825 16.7069 1.8 16.7988 1.8 16.9V17.4Z",
    fill: "#2B6ADE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPerson);
export default __webpack_public_path__ + "static/media/add-person.4e1e716adfc97d90914e0f3395cd557a.svg";
export { ForwardRef as ReactComponent };